import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { _breakP } from './utils.js';

gsap.registerPlugin(ScrollTrigger);

export default class Parallax {
  constructor() {
    this.init();
    this.bindLenis();
  }

  init() {
    const items = document.querySelectorAll('.js-parallaxPhoto');
    if (!items.length) return;

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        this.setup(entry.target);
        obs.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px 0px 0px' });

    items.forEach((el) => {
      const onlyDevice = el.dataset.onlyDevice;
      if (onlyDevice === 'pc' && _breakP.SP) return;
      if (onlyDevice === 'sp' && !_breakP.SP) return;
      observer.observe(el);
    });
  }

  setup(el) {
    const img = el.querySelector('.photo__image');
    if (!img) return;

    const scrubRaw = el.dataset.scrub;
    const scrubNum = Number(scrubRaw);
    const scrub = Number.isFinite(scrubNum) && scrubNum > 0 ? scrubNum : true;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: el,
        start: el.dataset.startPoint || 'top bottom',
        end: el.dataset.endPoint || 'bottom top',
        scrub
      }
    });

    tl.fromTo(img, {
      scale: _breakP.SP ? el.dataset.scaleStartSp : el.dataset.scaleStartPc,
      rotateX: _breakP.SP ? el.dataset.rotateStartSp : el.dataset.rotateStartPc,
      x: _breakP.SP ? el.dataset.xStartSp : el.dataset.xStartPc,
      y: _breakP.SP ? el.dataset.yStartSp : el.dataset.yStartPc
    }, {
      scale: _breakP.SP ? el.dataset.scaleEndSp : el.dataset.scaleEndPc,
      rotateX: _breakP.SP ? el.dataset.rotateEndSp : el.dataset.rotateEndPc,
      x: _breakP.SP ? el.dataset.xEndSp : el.dataset.xEndPc,
      y: _breakP.SP ? el.dataset.yEndSp : el.dataset.yEndPc,
      ease: 'none'
    });

    el.querySelectorAll('img').forEach((image) => {
      if (image.complete) return;
      image.addEventListener('load', () => {
        tl.scrollTrigger.refresh();
      }, { once: true });
    });
  }

  bindLenis() {
    // Sync ScrollTrigger updates with Lenis smooth-scroll frames if available.
    if (window.__lenisScrollTriggerBound) return;
    if (!window.__lenis || typeof window.__lenis.on !== 'function') return;
    window.__lenis.on('scroll', ScrollTrigger.update);
    window.__lenisScrollTriggerBound = true;
  }
}
